<template>
  <van-form @submit="onSubmit" ref="formData">
    <van-cell-group>
      <div class="myReview_text">
        <img
          src="../../../assets/game/yz_game_commentDetails_smile.png"
          alt=""
          @click.stop="changeToImg"
        />
        <van-field
          class="inputField"
          center
          :placeholder="state.inputTextDefault"
          type="textarea"
          rows="1"
          autosize
          v-model="state.inputText"
          @click.stop="openInputField"
          name="text"
          ref="inputFieldText"
        />
        <img
          src="../../../assets/game/yz_game_commentDetails_publish.png"
          alt=""
          @click="submitPublish"
        />
      </div>
      <!-- 图片评论区域 -->
      <div class="myReview_img" v-show="state.imgCommentFlag">
        <van-field name="uploader">
          <template #input>
            <van-uploader
              v-model="fileList"
              multiple
              :after-read="afterRead"
              :max-count="1"
              @click.stop="state.imgCommentFlag = true"
            />
          </template>
        </van-field>
      </div>
      <div class="emojiArea" v-show="state.emojiFlag">
        <emoji @getValue="getEmojiValue" @delEmoji="delEmojiValue" />
      </div>
    </van-cell-group>
  </van-form>
</template>

<script setup>
import { reactive, onActivated, defineEmits, ref } from "vue";
import emoji from "../../chat/components/emoji.vue";
import { enCodeEmoji, deCodeEmoji } from "@/utils/emojiToCode";
import { addTopicComment, stickComment } from "@/api/yzCommunity";
import { useStore } from "vuex";
import { Toast } from "vant";
import { getQueryString } from "@/utils/location.js";

const store = useStore();
const state = reactive({
  imgCommentFlag: false, // 图片评论标识
  showBottom: false, // 评论回复弹窗
  inputText: "",

  // 话题内容
  content: "",
});

const props = defineProps({
  id: {
    type: String,
    default: () => {},
  },
  gid: {
    type: Number,
    default: () => {},
  },
  topicType: {
    type: Number || String,
    default: () => {},
  },
});

const formData = ref(null);
const inputFieldText = ref(null);
const emit = defineEmits(["refreshComment"]);

onActivated(() => {
  // console.log('获取输入框光标位置-----------------',document.querySelector('.van-field__control').selectionStart)
});

// 图片回复评论
const fileList = ref([]);
const afterRead = (file) => {
  // 当设置 mutiple 为 true 时, file 为数组格式，否则为对象格式
  // console.log(file);
  // state.replyFile=file
};
// 表情回复
const changeToImg = () => {
  switch (true) {
    case state.imgCommentFlag && !state.showBottom:
      // 二级回复状态，打开表情，关闭图片评论
      state.emojiFlag = true;
      state.imgCommentFlag = false;
      break;
    case state.emojiFlag && !state.showBottom:
      // 二级回复状态，关闭表情，打开图片评论
      state.imgCommentFlag = true;
      state.emojiFlag = false;
      break;
    case !state.emojiFlag && state.showBottom:
      // 三级回复状态，打开表情
      state.emojiFlag = true;
      break;
    case state.emojiFlag && state.showBottom:
      // 三级回复状态，关闭表情，不显示图片评论
      state.emojiFlag = false;
      break;
    default:
      // 默认情况，可能需要根据实际需求添加额外的处理
      break;
  }
};

// 添加表情
const getEmojiValue = (value) => {
  // console.log('获取输入框光标位置-----------------',document.querySelector('.van-field__control').selectionStart)
  let index = document.querySelector(".van-field__control").selectionStart;
  let str = state.inputText;
  let str1 = str.slice(0, index);
  let str2 = str.slice(index);
  state.inputText = str1 + value + str2;
  // console.log('获取输入框光标位置-----------------',state.inputText)
};

//表情删除
const delEmojiValue = () => {
  state.inputText = state.inputText.slice(0, -2);
  // let index = document.querySelector(".van-field__control").selectionStart;
  // let str = state.inputText;
  // let str1 = str.slice(0, index);
  // let str2 = str.slice(index);
  // state.inputText = str1.slice(0, -2) + str2;
  // console.log('获取输入框光标位置-----------------',state.inputText)
};

// 防止图片回复和表情回复同时出现
const openInputField = () => {
  if (
    state.replyCommentId == state.comments_id &&
    !state.showBottom &&
    !state.emojiFlag
  ) {
    state.imgCommentFlag = true;
  }
};

const submitPublish = () => {
  // console.log("提交评论----------", formData.value.submit);
  formData.value.submit();
};

const onSubmit = (values) => {
  // console.log("回复内容-------------", values);
  let file = values.uploader[0];
  let formData = new FormData();
  for (let key in values) {
    formData.append(key, values[key]);
  }
  if (props.id) {
    formData.append("postid", props.id);
  }
  formData.append("gid", props.gid);
  formData.append("content", encodeURI(enCodeEmoji(state.inputText)));
  formData.append("uid", getQueryString("uid"));
  formData.append("username", getQueryString("mobile"));

  // 存在图片回复就添加图片，否则就不存在
  if (formData.get("uploader")) {
    formData.append("replyImg", file.file);
  }

  if (props.topicType == 3) {
    stickComment(formData).then((response) => {
      // console.log("stickComment", response);
      if (response.data.a == "1") {
        state.inputText = "";
        Toast("评论" + response.data.b);
        setTimeout(() => {
          emit("refreshComment");
        }, 300);
      } else {
        Toast(response.data.b);
      }
    });
  } else {
    addTopicComment(formData).then((response) => {
      // console.log('发送评论返回的结果------',response)
      if (response.data.a == "1") {
        state.inputText = "";
        Toast("评论" + response.data.b);
        setTimeout(() => {
          emit("refreshComment");
        }, 300);
      } else {
        Toast(response.data.b);
      }
    });
  }
};

// 点击全屏
const fullScreenClick = () => {
  // console.log('点击全屏')
  // 点击全屏时，收起图片输入
  if (state.imgCommentFlag || state.emojiFlag) {
    state.emojiFlag = false;
    state.imgCommentFlag = false;
  }
  // 输入框失去焦点
  inputFieldText.value.blur();
  state.inputTextDefault = "请输入回复内容...";
  console.log();
};

defineExpose({
  state,
  fullScreenClick,
});
</script>

<style scoped>
.van-cell-group {
  background-color: #fff;
}
.myReview_text {
  width: 100%;
  min-height: 150px;
  /* min-height: 68px;
        max-height: 200px; */
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  padding-top: 20px;
  border-top: 1px solid #f7f8fa;
}
.myReview_text img:nth-of-type(1) {
  width: 56px;
  height: 56px;
}
.myReview_text img:nth-of-type(2) {
  width: 72px;
  height: 72px;
}

.inputField {
  min-height: 72px;
  max-height: 200px;
  border-radius: 8px;
  background-color: #f1f1f1;
  display: flex;
  align-items: center;
  padding-left: 20px;
  overflow: auto;
  margin: 0 32px;
}

.myReview_img {
  width: 100%;
  padding: 0 36px;
  margin-top: 10px;
}
:deep(.van-uploader__upload) {
  border-radius: 20px;
  background-color: #f1f1f1;
}
:deep(.van-field__control) {
  color: #333;
}

/* 评论回复弹窗 */
.reviewBottom {
  /* height: 100%; */
  /* padding: 32px 32px 176px 32px; */
  padding-bottom: 200px;
  min-height: 200px;
}
.reviewBottom h3 {
  display: flex;
  justify-content: center;
  font-size: 28px;
  color: #333333;
  font-weight: 500;
  margin-top: 36px;
  margin-bottom: 32px;
}
.reviewBottom .main_content {
  padding: 0 32px 0 100px;
}
.commont_contentDetails {
  padding-top: 28px;
}
.commont_contentDetails > p {
  font-size: 28px;
  color: #333333;
  font-weight: 500;
  margin-left: 32px;
  margin-bottom: 28px;
}

:deep(.van-cell:after) {
  position: relative;
}

/* 表情输入区域 */
.emojiArea /deep/ .emoji {
  padding-left: 50px;
}
.emojiArea /deep/ .emoji ul {
  padding-left: 90px;
}
</style>
